import React, { useState, useEffect } from 'react';
import { getProducts } from '../services/api';
import ProductCard from '../components/ProductCard';
import './Sale.css';

export default function Sale() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setLoading(true);
        const res = await getProducts();

        let data = [];
        if (Array.isArray(res.data)) data = res.data;
        else if (res.data?.results) data = res.data.results;

        // ✅ Sale filter: discount ya old_price wale products
        const saleProducts = data.filter(
          (p) =>
            (p.discount_percentage && Number(p.discount_percentage) > 0) ||
            (p.old_price && Number(p.old_price) > Number(p.price))
        );

        if (!cancelled) setProducts(saleProducts);
      } catch (err) {
        if (!cancelled) {
          setError(err?.response?.data?.detail || 'Failed to load products');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, []);

  return (
    <div className="sale-page">
      {/* ══════════════════════════════════════
          Sale Banner
      ══════════════════════════════════════ */}
      <div className="sale-banner">
        <img
          src="https://images.unsplash.com/photo-1607083206968-13611e3d76db?w=1600&q=80"
          alt="Sale"
          className="sale-banner-img"
        />
        <div className="sale-banner-overlay" />
        <div className="sale-banner-content">
          <span className="sale-banner-tag">🔥 Limited Time</span>
          <h1 className="sale-banner-title">Mega Sale</h1>
          <p className="sale-banner-subtitle">
            Up to <strong>70% OFF</strong> on selected items
          </p>
        </div>
        <div className="sale-banner-badge">
          <span className="sale-badge-num">70%</span>
          <span className="sale-badge-label">OFF</span>
        </div>
      </div>

      {/* ══════════════════════════════════════
          Products Grid
      ══════════════════════════════════════ */}
      <div className="sale-container">
        {loading ? (
          <div className="sale-loading">
            <div className="sale-spinner" />
            <p>Finding best deals…</p>
          </div>
        ) : error ? (
          <div className="sale-error">⚠️ {error}</div>
        ) : products.length === 0 ? (
          <div className="sale-empty">
            <div className="sale-empty-icon">🏷️</div>
            <p>No sale items right now.</p>
            <span>Check back soon for amazing deals!</span>
          </div>
        ) : (
          <>
            <div className="sale-count">
              🔥 {products.length} {products.length === 1 ? 'deal' : 'deals'} available
            </div>
            <div className="sale-grid">
              {products.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}